/* ==========================================================================
   UGC Review — Mobile Carousel Progress Bar + Video Playback
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-review';
  var MEDIA_SELECTOR = '.oddit-section-ugc-review__card-media';
  var VISIBILITY_THRESHOLD = 0.5;

  function initProgressBar(section) {
    var cards = section.querySelector('.oddit-section-ugc-review__cards');
    var fill = section.querySelector('.oddit-section-ugc-review__progress-fill');
    if (!cards || !fill) return;

    function update() {
      var scrollWidth = cards.scrollWidth;
      var clientWidth = cards.clientWidth;
      var maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        fill.style.width = '100%';
        fill.style.left = '0';
        return;
      }

      var thumbPct = (clientWidth / scrollWidth) * 100;
      var leftPct = (cards.scrollLeft / maxScroll) * (100 - thumbPct);

      fill.style.width = thumbPct + '%';
      fill.style.left = leftPct + '%';
    }

    cards.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function resetCard(media) {
    media.classList.remove('is-playing');
    var video = media.querySelector('[data-ugc-video]');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (e) {}
    video.muted = true;
    video.controls = false;
    video.setAttribute('aria-hidden', 'true');
  }

  function initPlayButtons(section) {
    var mediaEls = section.querySelectorAll(MEDIA_SELECTOR);

    section.querySelectorAll('[data-ugc-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest(MEDIA_SELECTOR);
        if (!media) return;

        var video = media.querySelector('[data-ugc-video]');
        if (!video) return;

        mediaEls.forEach(function (other) {
          if (other !== media && other.classList.contains('is-playing')) {
            resetCard(other);
          }
        });

        if (!video.src) {
          var src = video.getAttribute('data-src');
          if (!src) return;
          video.src = src;
        }

        video.muted = false;
        video.controls = true;
        video.removeAttribute('aria-hidden');
        media.classList.add('is-playing');

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });

    section.querySelectorAll('[data-ugc-video]').forEach(function (video) {
      video.addEventListener('ended', function () {
        var media = video.closest(MEDIA_SELECTOR);
        if (media) resetCard(media);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (
              entry.intersectionRatio < VISIBILITY_THRESHOLD &&
              entry.target.classList.contains('is-playing')
            ) {
              resetCard(entry.target);
            }
          });
        },
        { threshold: [0, VISIBILITY_THRESHOLD, 1] }
      );
      mediaEls.forEach(function (media) {
        io.observe(media);
      });
    }
  }

  function initSection(section) {
    initProgressBar(section);
    initPlayButtons(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
